// extracted by mini-css-extract-plugin
export default {"spacing":"30px","userDetailsContainer":"UserDetails_userDetailsContainer__-YLIB","userDetails":"UserDetails_userDetails__hc14W","smallArrow":"UserDetails_smallArrow__NeVQ-"};